import Haki from "./Haki";

export default Haki;
